import React from 'react'
import { formatMoney } from '../../../utils/amount'
import { sumSettlementForecast } from './helpers'

const SettlementForecastFooter = ({ forecast = [] }) => {
  const total = sumSettlementForecast(forecast)

  return (
    <div
      className="rounded-2xl border border-divider bg-paper px-6 py-4 flex flex-wrap items-center gap-6"
      data-testid="settlement-forecast-footer"
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-text-secondary">Settlement Forecast</p>
      <div className="flex flex-wrap items-center gap-6 flex-1">
        {forecast.length === 0 && <p className="text-sm text-text-secondary">No upcoming settlements forecasted.</p>}
        {forecast.map((entry) => (
          <div key={entry.date} data-testid={`forecast-entry-${entry.date}`}>
            <p className="text-xs text-text-secondary">{entry.label || entry.date}</p>
            <p className="text-sm font-medium text-text-primary">{formatMoney(entry.amount)}</p>
          </div>
        ))}
      </div>
      <div className="ml-auto text-right">
        <p className="text-xs text-text-secondary">Total Forecasted</p>
        <p className="text-lg font-semibold text-text-primary" data-testid="settlement-forecast-total">
          {formatMoney(total)}
        </p>
      </div>
    </div>
  )
}

export default SettlementForecastFooter
